import dynamic from 'next/dynamic';
import { MemberOptionProps } from './MemberOption.types';

export const MemberOption = dynamic<MemberOptionProps>(() =>
  import('./MemberOption').then(module => module.MemberOption)
);
